import React, { useState, useEffect } from 'react';
import {
  Modal,
  Button,
  FormGroup,
  ControlLabel,
  FormControl, Alert,
} from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import qs from 'qs';
import { delay, getErrorMessage } from '../../../../../utils/helper';
import { getOrderDetails, resendOrdersUrl } from '../../../../../services/endpoints/orders';

import AlertComponent from '../../../../../components/Alert';
import Loader from '../../../../../components/Loaders/Loader';
import Spinner from '../../../../../components/Loaders/Spinner';

const OrderDetailsModal = ({ data, onHide, onSubmit }) => {
  const [error, setError] = useState(null);
  const [isLoading, setLoading] = useState(false);
  const [modalData, setModalData] = useState({
    init: false,
    success: false,
    error: null,
    resendOrder: false,
    details: [],
  })
  const { init, resendOrder, details, success } = modalData;

  const isOperationTimeOut = data?.order_fail_reason === 8;

  const queryParams = qs.parse(window.location.search.slice(1));

  const onResetOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await resendOrdersUrl(data.id, queryParams);
      setModalData((prevState) => ({
        ...prevState,
        success: true,
      }))
      await delay(500);
      onSubmit(response.data)
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setError(errorMessage);
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      const response = await getOrderDetails(data.id);
      if (response?.data) {
        setModalData((prevState) => ({
          ...prevState,
          init: true,
          details: response.data,
          resendOrder: data?.access?.resend_order || false,
        }));
      }
    } catch (error) {
      const errorMessage = getErrorMessage(error);
      setModalData((prevState) => ({
        ...prevState,
        init: true,
      }))
      setError(errorMessage);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isOperationTimeOut
          ? (
            <Alert bsStyle="warning">
              No response from provider. Order creation status is unknown. This means we didn't get an API response from the provider on time. It could be due to server issues or inefficient algorithms on the provider’s side.
            </Alert>
          ) : null}
        {isLoading ? <Loader success={success} /> : null}
        {error ? <AlertComponent text={error} type="danger" /> : null}
        {init ? (
          <>
            {details?.map((detail, index) => {
              if (detail.fieldKey === 'content' && isEmpty(detail.value)) return null;

              return (
                <FormGroup key={index}>
                  {detail.label && <ControlLabel>{detail.label}</ControlLabel>}
                  <FormControl rows={7} componentClass={detail.type} name={detail.name} readOnly value={detail.value} />
                </FormGroup>
              )
            })}
          </>
        ) : <Spinner />}
      </Modal.Body>
      <Modal.Footer className="custom__modal-footer">
        {resendOrder
          ? (
            <Button
              onClick={onResetOrder}
              disabled={isLoading}
              bsStyle="primary"
              type="button"
            >
              Resend order
            </Button>
          ) : null}
        <Button
          disabled={isLoading}
          onClick={onHide}
        >
          Close
        </Button>
      </Modal.Footer>
    </>
  );
};

OrderDetailsModal.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  onHide: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default OrderDetailsModal;
